import React from 'react'
import styles from './FormEdit.module.scss'
import profile from 'assets/image50.png'
import { Button } from 'components/Button/Button'
import { Input } from 'components/Input/Input'
import { COLORS_DATA } from './consts'
import { Icon } from 'components/Icon/Icon'
import { MultiRowInput } from 'components/MultiRowInput/MultiRowInput'
import { Chips } from 'components/Chips/Chips'
import { UserInfoType } from 'components/UserInfo/UserInfo'
import { useAppDispatch } from 'redux/hooks'
import classnames from 'classnames'
import { updateTheme } from 'redux/rootSlice/rootSlice'


type Props = {
    onChange?: (credential: any) => void,
    title: string,
    data?: UserInfoType,
    theme?: string,
}

export function FormEdit(props: Props) {
    // const [selectedColor, setSelectedColor] = React.useState(props.theme)
    const [credentials, setCredentials] = React.useState({
        file: props.data.file,
        name: props.data.name,
        link: props.data.link,
        about: props.data.about,
        twitter: props.data.twitter,
        instagram: props.data.instagram,
        facebook: props.data.facebook,
        patrons: props.data.patrons,
        drizzles: props.data.drizzles
    })

    const dispatch = useAppDispatch()

    const fileInputRef = React.useRef(null);

    function handleCredentials(target) {
        const data = {
            ...credentials,
            [target.name]: target.value,
        }

        setCredentials(data)
        props.onChange(data)
    }

    function handleItemClick(item) {
        dispatch(updateTheme(item.color))
        // setSelectedColor(item.value)
    }

    function handleFileChange(event) {
        const file = event.target.files[0]
        setCredentials({
            ...credentials,
            file: file,
        })
    }

    function handleUpload() {
        fileInputRef.current.click();
        // Здесь можно добавить код для загрузки файла на сервер
        if (credentials.file) {
            console.log("Загружен файл:", credentials.file)
            // Добавьте здесь логику для отправки файла на сервер
        } else {
            console.log("Файл не выбран")
        }
    }

    const colorClassNames = classnames({
        [styles['colors__item']]: true,
        [styles[`colors__item_${props.theme}`]]: true
    })


    return (
        <div className={styles['wrapper']}>
            <span className={styles['title']}>{props.title}</span>
            <div className={styles['profile']}>
                <img src={profile} className={styles['img']} alt='logo_mini' />
                <div className={styles['profile__wrapper']}>
                    <span className={styles['description']}>
                        Image should be at least 1024×1024px and must be in JPG or PNG format.
                    </span>
                    <div className={styles['buttons']}>
                        <Button
                            size='xs'
                            type='border'
                            stretch={false}
                            onClick={handleUpload}>
                            Upload
                        </Button>
                        <Button
                            size='xs'
                            type='border'
                            stretch={false}
                            onClick={() => { }}>
                            Remove
                        </Button>
                    </div>
                </div>
            </div>
            <input
                ref={fileInputRef}
                type="file"
                style={{ display: 'none' }}
                onChange={handleFileChange}
            />
            <Input
                size='m'
                label='Name'
                type='text'
                name='name'
                value={credentials.name}
                onChange={handleCredentials}
            />
            <Input
                size='m'
                label='Drizzle page link'
                type='text'
                name='link'
                value={credentials.link}
                isChecked={true}
                onChange={handleCredentials}
            />
            <MultiRowInput
                label='About'
                name='about'
                value={credentials.about}
                onChange={handleCredentials}
            />
            {props.data.defaultColor && (
                <div>
                    <span className={styles['label']}>Background</span>
                    <div className={styles['colors']}>
                        {COLORS_DATA.map((item) => {
                            return (
                                <div
                                    key={item.id}
                                    className={styles['colors__item']}
                                    onClick={() => handleItemClick(item)}
                                    style={{ backgroundColor: item.value }}>
                                    {props.theme === item.color && <Icon name='done' />}
                                </div>
                            )
                        })}
                    </div>
                </div>
            )}
            <div>
                <span className={styles['label']}>Social links</span>
                <div className={styles['chips']}>
                    <Chips
                        name='twitter'
                        title='X'
                        iconName='twitter'
                        value={credentials.twitter}
                    />
                    <Chips
                        name='instagram'
                        title='Instagram'
                        iconName='instagram'
                        value={credentials.instagram}
                    />
                    <Chips
                        name='facebook'
                        title='Facebook'
                        iconName='facebook'
                        value={credentials.facebook}
                    />
                </div>
            </div>
        </div>
    );
}